// assets
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import config from 'config';

// icons
const icons = {
    AdminPanelSettingsIcon
};

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const admin = {
    id: 'group-admin',
    title: 'Admin',
    type: 'group',
    subscriptionRequired:['basic','standard','premium','enterprise','admin'],
    children: [
        {
            id: 'admin',
            title: 'Admin',
            type: 'item',
            url: '/admin',
            icon: icons.AdminPanelSettingsIcon,
            breadcrumbs: false,
            showInShopifyApp: true,
        }
    ]
};

export default admin;
